import { Component} from '@angular/core';

@Component({
    selector: 'contact-main',
    templateUrl: './contact-main.tmpl.html'
})

export class ContactMain {
    editMode: boolean = null; 

    public setVal(val:boolean) {
        this.editMode = val;  
    }
}
  